import { Select, Space, Typography } from 'antd'

export const InspectionAreaSourceBoxChooser = ({
  value,
  disabled,
  options,
  onChange,
}: {
  value?: number
  disabled: boolean
  options: { value: number; label: string }[]
  onChange: (boxIndex: number) => void
}) => (
  <Space orientation='vertical' size={4}>
    <Typography.Text id='source-box-choice-label'>
      Source drawing box
    </Typography.Text>
    <Select
      aria-label='Source drawing box'
      value={value}
      disabled={disabled}
      placeholder='Choose a numbered source box'
      onChange={onChange}
      options={options}
    />
  </Space>
)
